module.exports = __webpack_public_path__ + "img/logo4.6a87ad12.png";